import { computed } from 'vue';
import { useLocalizationStore } from '@/stores/localization';

const getImageLanguage = computed(() => {
  const { language } = useLocalizationStore();
  return language === 'nl' ? 'nl' : 'en';
});

export default getImageLanguage;
